import React, { useEffect, useState } from 'react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(5 * 60 + 8);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const timeString = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="sticky top-0 z-50 w-full" data-id="element-284">
      <a href="https://checkout.construyeprogreso.com/cart/48119785324714:1" className="block w-full bg-red-600 text-white py-1 px-4 text-center shadow-md hover:bg-red-700 transition-colors cursor-pointer pt-[4px] pb-[4px] pl-[16px] pr-[16px]" data-id="element-285">
        <p className="text-[12px] font-bold uppercase tracking-wide flex items-center justify-center gap-2" data-id="element-286">
          <span data-id="element-287">⏳ OFERTA EXPIRA EN: {timeString}</span>
          <span data-id="element-288">|</span>
          <span data-id="element-289">🔥 SOLO QUEDAN 3 CUPOS</span>
        </p>
        <p className="text-[11px] font-medium text-red-100 mt-0.5" data-id="element-290">
          🔧 Para personas que quieren vivir del detailing profesional
        </p>
      </a>
    </div>;
}